import React from "react";
import styled from "styled-components";
import { Toast } from "@sonder/ui/source/styled/fragments/Toast";
import { zIndex } from "@sonder/ui/source/styled/theme";
import { OfflineToast } from "core/components/OfflineToast";
import { BatchingToast as ScheduleBatchingToast } from "schedule/components/BatchingToast";
import { SequentialToast as ScheduleSequentialToast } from "schedule/components/SequentialToast";
import { useStore as useScheduleStore } from "schedule/store";
import { BatchingToast as TasksBatchingToast } from "tasks/components/BatchingToast";
import { UndoToast as TasksUndoToast } from "tasks/components/UndoToast";
import { UploadAttachmentsToast } from "tasks/components/UploadAttachmentsToast";
import { useStore as useTasksStore } from "tasks/store";
import { UndoToast as TeamUndoToast } from "team/components/UndoToast";

const StyledToaster = styled.div`
  left: 1rem;
  position: fixed;
  bottom: 1rem;
  z-index: ${zIndex.toaster};

  ${Toast} + ${Toast} {
    margin-top: 1rem;
  }
`;

export const Toaster = () => {
  const {
    state: { batchJobs: tasksBatchJobs, uploadAttachments },
  } = useTasksStore();
  const {
    state: {
      batchJobs: scheduleBatchJobs,
      sequentialJobs: scheduleSequentialJobs,
    },
  } = useScheduleStore();
  return (
    <StyledToaster>
      <TasksUndoToast />
      <TeamUndoToast />
      {tasksBatchJobs.map(batchJobId => (
        <TasksBatchingToast jobId={batchJobId} key={batchJobId} />
      ))}
      {scheduleBatchJobs.map(batchJobId => (
        <ScheduleBatchingToast jobId={batchJobId} key={batchJobId} />
      ))}
      {scheduleSequentialJobs.map(sequentialJob => (
        <ScheduleSequentialToast
          job={sequentialJob}
          key={sequentialJob.jobId}
        />
      ))}
      {uploadAttachments.map(uploadAttachment => (
        <UploadAttachmentsToast
          key={uploadAttachment.attachableId}
          {...uploadAttachment}
        />
      ))}
      <OfflineToast />
    </StyledToaster>
  );
};
